import g from '#core/global';
import load from '#core/load';


const container_$ = '.media-figure__media--lazy';
const image_$ = '.media-figure__source--lazy';
let has_lazy = false;
let $all_containers = null;


const module = {
	loading_c: 'image--lazy--loading',
	done_c: 'image--lazy--done',
	error_c: 'image--lazy--error',
	
	
	/**
	 * Init module
	 */
	init() {
		if (load.ran('lazy')) return false;
		
		load.content(() => {
			has_lazy = assign_elements();
			if (!has_lazy) return false;
		});
		load.all(() => {
			has_lazy = assign_elements();
			if (!has_lazy) return false;
			
			// setTimeout(() => {
			// 	show_all();
			// }, 500);
		});
		
		init_load_new_images();
	},
	
	
	/**
	 * Load images
	 */
	load() {
		assign_elements();
	},
	
	
	/**
	 * Has this image loaded?
	 * @param {element} $image
	 * @return {boolean}
	 */
	isLoaded($image) {
		return $image.complete && $image.naturalHeight !== 0;
	},
	
};

export default module;
module.init();


/**
 * Assign elements and event listeners
 * @return {boolean}
 */
function assign_elements() {
	if (has_lazy) return true;
	
	// TODO: do not store objects on load, account for dynamic content
	const unloaded_$ = `${container_$}:not(.${module.loading_c}, .${module.done_c})`;
	$all_containers = document.querySelectorAll(unloaded_$);
	if (!$all_containers.length) return false;
	
	$all_containers.forEach($container => {
		load_images($container);
	});
	
	return true;
}


/**
 * Load images
 * @param {element} $container
 */
function load_images($container) {
	if ($container.classList.contains(module.done_c)) return false;
	
	const unloaded_images = [];
	$container.querySelectorAll(image_$).forEach($image => {
		if (module.isLoaded($image)) return false;
		
		unloaded_images.push($image);
		$image.addEventListener(g.load_e, function done(e) {
			$image.removeEventListener(g.load_e, done);
			show($container);
		});
		$image.addEventListener(g.error_e, function error(e) {
			$container.classList.add(module.done_c);
			$container.classList.add(module.error_c);
			$image.removeEventListener(g.error_e, error);
		});
	});
	
	if (!unloaded_images.length) {
		show($container);
		return false;
	}
	
	$container.classList.add(module.loading_c);
}


/**
 * Watch for newly added images
 */
function init_load_new_images() {
	const observer = new MutationObserver(load_new_images);
	observer.observe(document.body, {
		childList: true,
		subtree: true,
	});
}


/**
 * Load images added dynamically
 * @param {MutationRecord[]} records
 * @param {MutationObserver} observer
 */
function load_new_images(records, observer) {
	for (let mutation of records) {
		if (mutation.type !== 'childList') continue;
		
		mutation.addedNodes.forEach($node => {
			if ($node.nodeType !== Node.ELEMENT_NODE) return false;
			
			const $images = $node.querySelectorAll(image_$);
			if (!$images.length) return false;
			
			$node.querySelectorAll(container_$).forEach($container => {
				load_images($container);
			});
		});
	}
}


/**
 * Show image
 * @param {element} $container
 */
function show($container) {
	if (Array.from($container.classList).includes(module.done_c)) return false;
	
	// TODO: remove loading indicator when done
	$container.classList.add(module.done_c);
	$container.classList.remove(module.loading_c);
}


/**
 * Try to show all loaded images when page is done loading
 * 
 * This is designed to circumvent a situation where an image is loaded, but its
 * container classes are not updated. It's possible that this happens only when
 * the image is cached, or when testing locally, or when the network connection
 * is otherwise insanely fast.
 * 
 * @deprecated Made obsolete by properly checking images on load
 */
function show_all() {
	$all_containers.forEach($container => {
		const unloaded_images = [];
		$container.querySelectorAll(image_$).forEach($image => {
			if (module.isLoaded($image)) return false;
			
			unloaded_images.push($image);
		});
		if (!unloaded_images.length) return false;
		
		show($container);
	});
}
